import _extends from '@babel/runtime/helpers/extends';
import { colors } from '../constants/colors.js';
import { spacingNumerical } from '../constants/spacing.js';

var chipsThemeNative = {
  color: 'primary',
  background: 'background',
  text: 'text',
  height: 40,
  padding: {
    /**
     * Padding between the conent and the borders
     */
    horizontal: spacingNumerical.xxs
  },
  borders: {
    color: colors.fogGrey,
    radius: spacingNumerical.xxs,
    width: 2
  }
};
var chipsDarkThemeNative = _extends({}, chipsThemeNative, {
  borders: {
    color: colors.octoberGrey,
    radius: spacingNumerical.xxs,
    width: 2
  }
});
var chipsThemeWeb = {
  color: 'primary',
  background: 'background',
  text: 'text',
  height: 40,
  padding: {
    /**
     * Padding between the conent and the borders
     */
    horizontal: spacingNumerical.xxs
  },
  borders: {
    radius: 16,
    width: 2
  },
  active: {
    text: 'background'
  },
  inactive: {
    border: colors.fogGrey,
    text: colors.fogGrey,
    background: colors.lightGrey
  }
};
var chipsDarkThemeWeb = _extends({}, chipsThemeWeb, {
  inactive: _extends({}, chipsThemeWeb.inactive, {
    border: colors.octoberGrey,
    text: colors.octoberGrey,
    background: colors.inkGrey
  })
});

export { chipsDarkThemeNative, chipsDarkThemeWeb, chipsThemeNative, chipsThemeWeb };
